import { Crown } from "lucide-react";

// Permanent "Founding Member" emblem for the first students at each campus.
export function FoundingBadge({ compact = false, className = "" }) {
  if (compact) {
    return (
      <span
        title="Founding Member"
        aria-label="Founding Member"
        data-testid="founding-badge"
        className={`inline-flex items-center justify-center rounded-full bg-gradient-to-br from-amber-300 to-amber-500 text-amber-950 w-5 h-5 shadow-sm shrink-0 ${className}`}
      >
        <Crown size={12} strokeWidth={2.2} />
      </span>
    );
  }
  return (
    <span
      data-testid="founding-badge"
      className={`inline-flex items-center gap-1.5 rounded-full bg-gradient-to-br from-amber-300 to-amber-500 text-amber-950 text-[11px] font-bold uppercase tracking-widest px-2.5 py-1 shadow-sm ${className}`}
    >
      <Crown size={12} strokeWidth={2.4} /> Founding Member
    </span>
  );
}
